module.exports = __webpack_public_path__ + "2b4ac920c007e348c1865df90fda5c97.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/floatie-watermelon-s.png
// module id = 1893
// module chunks = 0